import { render, staticRenderFns } from "./ClosePayrollPeriod.vue?vue&type=template&id=596cffda"
import script from "./ClosePayrollPeriod.vue?vue&type=script&lang=js"
export * from "./ClosePayrollPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports